import { PdfGen, PdfUnit, PdfSize, PdfRect } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import { calcOrigin } from '../../core/genHelper';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/shapes';
import '../../pdf/draw/label';

/**
 * Trychtyr (Funnel Cards)
 *
 * Layout: Landscape A4, 5x2 grid of funnel cards.
 * Each card has a question at top, funnel in middle, answer at bottom.
 *
 * Migrated from C# EduFrame.Single.Generators.Trychtyr
 */
export class Trychtyr implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const countX = 5;
    const countY = 2;
    const { origin, size } = calcOrigin(countX, countY, margin, PdfSize.A4H);
    const cellWidth = size.width;
    const cellHeight = size.height;
    const rowHeight = cellHeight / 3;

    const pageCount = Math.ceil(opts.list.length / (countX * countY));

    for (let p = 0; p < pageCount; p++) {
      const page = pdf.addPage(true);
      const startIndex = p * countX * countY;
      const endIndex = Math.min(startIndex + countX * countY, opts.list.length);
      const pageItems = opts.list.slice(startIndex, endIndex);

      const leftTexts = pageItems.map((item) => [item.left.getText() ?? '']);
      const rightTexts = pageItems.map((item) => [item.right.getText() ?? '']);

      const f1 = page.adjustFontMulti(leftTexts, GUtil.baseFont, new PdfSize(cellWidth, rowHeight));
      const f2 = page.adjustFontMulti(
        rightTexts,
        GUtil.baseFont,
        new PdfSize(cellWidth, rowHeight)
      );

      for (let x = 0; x < countX; x++) {
        for (let y = 0; y < countY; y++) {
          const indexOnPage = x * countY + y;
          if (indexOnPage >= pageItems.length) continue;

          const item = pageItems[indexOnPage];

          const rect = new PdfRect(
            origin.x + x * cellWidth,
            origin.y + y * cellHeight,
            cellWidth,
            cellHeight
          );

          const r1 = new PdfRect(rect.x, rect.y, rect.width, rowHeight);
          const r2 = new PdfRect(rect.x, r1.bottom, rect.width, rowHeight);
          const r3 = new PdfRect(rect.x, r2.bottom, rect.width, rowHeight);

          const r2a = new PdfRect(r2.x + r2.width / 4, r2.y, r2.width / 2, r2.height);

          page.drawLabel(item.left, { rect: r1, font: f1 });
          page.drawLabel(item.right, { rect: r3, font: f2 });

          page.drawFunnel(r2a, null, GUtil.basePen);

          page.drawRectangle(GUtil.cutPen, null, rect);
        }
      }
    }
  }
}
